import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import {map} from "rxjs/operators";
import {ConfigurationDataService} from "./configuration-data.service";
import {ConfigurationModel} from "./configuration.model";

@Injectable({
  providedIn: 'root'
})
export class ConfigurationModelResolver  {
  constructor(private configurationService: ConfigurationDataService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ConfigurationModel> {
    return this.configurationService.get(route.params.id).pipe(map(configuration => {
      route.routeConfig.data ??= {};
      route.routeConfig.data['breadcrumb'] = configuration?.Code;
      route.routeConfig.data['search'] = {
        enabled: false
      };
      return configuration;
    }));
  }
}

